import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import DashboardShell from "../components/DashboardShell";
import PostCard from "../components/PostCard";
import { api } from "../lib/api";
import { Hash } from "lucide-react";

export default function HashtagPage() {
  const { tag } = useParams();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/feed/hashtag/${tag}`).then((r) => setItems(r.data.items || [])).finally(() => setLoading(false));
  }, [tag]);

  return (
    <DashboardShell>
      <div className="space-y-5" data-testid={`hashtag-page-${tag}`}>
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-md border border-[rgba(0,170,255,0.18)] flex items-center justify-center" style={{ boxShadow: "0 0 14px rgba(0, 170, 255,0.3)" }}>
            <Hash className="text-[#00aaff]" size={22} />
          </div>
          <div>
            <div className="font-mono-tech text-[10px] uppercase tracking-[0.32em] text-[#39ff14]">// Hashtag</div>
            <h1 className="text-2xl lg:text-3xl font-semibold">#{tag}</h1>
          </div>
        </div>
        {loading ? (
          <div className="font-mono-tech text-xs text-[#94a3b8] uppercase tracking-wider">Loading…</div>
        ) : items.length === 0 ? (
          <div className="csc-card p-8 text-center text-[#94a3b8]" data-testid="empty-hashtag">
            No posts use this hashtag yet. <Link to="/home" className="csc-link">Be the first →</Link>
          </div>
        ) : (
          items.map((p) => <PostCard key={p.id} post={p} />)
        )}
      </div>
    </DashboardShell>
  );
}
